import { Link } from 'react-router-dom'
import { FiChevronRight as FiBreadcrumb } from 'react-icons/fi'
import Layout from '../components/Layout/Layout'

const FAQ = () => {
  const faqData = [
    {
      id: 1,
      question: '¿Son fabricantes?',
      answer: 'Sí, Arca es una empresa con productos propios.'
    },
    {
      id: 2,
      question: '¿De dónde son?',
      answer: 'Somos mexicanos. Específicamente de Jalisco municipio de Ayotlan, La Ribera.'
    },
    {
      id: 3,
      question: '¿Pueden hacer trabajos especiales?',
      answer: 'Claro que sí. Contáctando a nuestros números.'
    },
    {
      id: 4,
      question: '¿Venden mayoreo?',
      answer: 'Claro. A partir de las 12 piezas de nuestros catálogos.'
    },
    {
      id: 5,
      question: '¿Hacen envíos?',
      answer: 'Claro. Tenemos envíos nacionales e internacionales.'
    },
    {
      id: 6,
      question: '¿Qué material utilizan?',
      answer: 'Cristal cortado, latón y baños de plata y oro, oro rosa y negro.'
    },
    {
      id: 7,
      question: '¿En cuánto tiempo entregan?',
      answer: 'De 1 a 15 días, dependiendo la cantidad.'
    }
  ]

  return (
    <Layout>
      <div className="py-8 sm:py-12">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Breadcrumb */}
          <nav className="flex items-center text-sm sm:text-base text-primary-gray mb-4 sm:mb-6 font-body font-extralight flex-wrap" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-primary-dark hover:font-normal transition-colors">
              Inicio
            </Link>
            <FiBreadcrumb className="mx-1 sm:mx-2 flex-shrink-0" />
            <span className="font-normal">
              Preguntas frecuentes
            </span>
          </nav>

          {/* Page Header */}
          <div className="mb-8">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-title font-semibold text-primary-text mb-4">
              Preguntas frecuentes
            </h1>
          </div>
                    
          {/* FAQ List - Static Display */}
          <div className="space-y-6">
            {faqData.map((item) => (
              <div key={item.id}>
                <h3 className="font-normal text-primary-text text-xl font-body mb-2">
                  {item.question}
                </h3>
                <p className="font-light text-primary-text text-lg font-body leading-relaxed ml-4">
                  {item.answer}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  )
}
export default FAQ